import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core/index'
import { orderReserve } from '../../../../helpers/restHelpers'
import { strings } from '../../../../localization/strings'
import Loader from '../../../loaders/dots_loader/index'
import { withRouter } from 'react-router-dom'

class ReservationAllDialog extends React.Component {
    state = { open: false, loading: false }

    handleClickOpen = () => {
        this.setState({ open: true })
    }

    handleClose = (force) => {
        if (force !== true) {
            if (this.state.loading) return
        }
        this.setState({ open: false, loading: false})
    }

    confirm = () => {
        this.setState({ loading: true })
        orderReserve(this.props.orderId)
            .then(() => {
                this.handleClose(true)
                window.showDialog(
                    {
                        title: strings.orderReserveSuccessTitle,
                        message: strings.orderReserveSuccess,
                    },
                    () => this.props.actionDone()
                )
            })
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    render() {
        return (
            <div style={{ width: '100%' }}>
                <div onClick={this.handleClickOpen}>
                    {strings.orderReserveButton}
                </div>

                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {strings.orderReserveDialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            id="alert-dialog-description"
                            style={{ whiteSpace: 'pre-line' }}
                        >
                            {strings.orderReserveDoorDialogText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleClose}
                            color="primary"
                            disabled={this.state.loading}
                        >
                            {strings.close}
                        </Button>
                        <Button
                            onClick={this.confirm}
                            color="primary"
                            autoFocus
                        >
                            {strings.continue}
                        </Button>
                    </DialogActions>
                    {this.state.loading ? <Loader /> : null}
                </Dialog>

            </div>
        )
    }
}

export default withRouter(ReservationAllDialog)
